import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { SJAdminSidebar } from '@/components/admin/sj-admin-sidebar';
import { SJAdminHeader } from '@/components/admin/sj-admin-header';

export function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-[var(--sj-bg)]">
      <SJAdminSidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <SJAdminHeader onMenuToggle={() => setCollapsed(!collapsed)} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
